import Intl from 'dna-react-intl/components/intl/Intl';
import { connect } from 'react-redux';
import stringsTable from '../lib/i18n/lang';

function mapStateToProps(state) {
	return {
		locale: state.APP_locale,
	};
}

export default ComposedComponent => {
	return connect(mapStateToProps, null)(Intl(ComposedComponent, stringsTable));
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/mixins/Intl.js